import { createAction } from 'redux-action';
import axios from 'axios';
import { get_service_endpoint } from '../../ServiceEndpoints.js';
import { AxiosCallError, requestApi, showErrorPage } from './commonActions';
import { onLoadModal } from './commonActions';
import { notification } from 'antd';
import { history } from '../../index';
import { parseTheme } from '../../Utils/serializer';
import { defaultTheme } from '../../const';
import analytics from '../../services/analytics';

let ep = get_service_endpoint('cs-auth');
let catalog_ep = get_service_endpoint('cs-course-catalog');

let ep2 = get_service_endpoint('interview');

export const loginSuccess = createAction('LOGIN_SUCCESS');

export const stateCleanup = createAction('STATE_CLEANUP');

export const signUpSuccess = createAction('SIGNUP_SUCCESS');

export const getUserInfoSuccess = createAction('GET_USER_INFO_SUCCESS');

export const getMatchingCitiesSuccess = createAction('GET_MATCHING_CITIES');

export const getAllStatesSuccess = createAction('GET_ALL_STATES');

export const FilterLocationsSuccess = createAction('FILTER_LOCATIONS');

export const getcompanyInfoSuccess = createAction('GET_COMPANY_INFO_SUCCESS');

export const otpRequested = createAction('OTP_REQUESTED');

export const otpLogin = createAction('OTP_LOGIN');

export const setAuthError = createAction('SET_AUTH_ERROR');

export const otpFailure = createAction('OTP_FAILURE');

// helper to replace previous `flash` action usage with antd notifications
const openNotification = (payload = {}, duration = 2.5) => {
  const title = payload.title || payload.message || '';
  const type = payload.type || '';
  const config = { message: title, duration };
  if (type.toLowerCase && type.toLowerCase() === 'success') {
    notification.success(config);
  } else {
    // treat anything else as an error/failure
    notification.error(config);
  }
};

export const getUserInfoRequest = () => {
  let axiosConfig = {
    headers: {
      'X-Access-Token': localStorage.getItem('access-token'),
      'X-Refresh-Token': localStorage.getItem('refresh-token'),
    },
  };
  return dispatch => {
    axios
      .get(`${ep}/api/self/`, axiosConfig)
      .then(response => {
        if (response.success) {
          dispatch(getUserInfoSuccess(response.data));
        }
        dispatch(requestApi(false));
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
      });
  };
};

export const loginRequest = payload => {
  return dispatch => {
    dispatch(requestApi(true));
    axios
      .post(`${ep}/api/login/`, {
        email: payload.emailId,
        password: payload.password,
      })
      .then(response => {
        if (response.success) {
          localStorage.setItem('access-token', response.data['access_token']);
          localStorage.setItem('refresh-token', response.data['refresh_token']);
          if (response.data.user_id) analytics.setLocalUserId(response.data.user_id);
          axios.defaults.headers.common['X-Access-Token'] = response.data['access_token'];
          axios.defaults.headers.common['X-Refresh-Token'] = response.data['refresh_token'];
          dispatch(loginSuccess(response.data));
          analytics.setUserContext();
          dispatch(onLoadModal({ modalType: '', modalContent: '', showModal: false }));
          if (payload.callback) payload.callback();
        } else {
          openNotification({ message: 'Invalid Username/Password', type: 'failure' }, 2.5);
        }
        dispatch(requestApi(false));
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
      });
  };
};

export const loginUsingFacebook = payload => {
  return dispatch => {
    dispatch(requestApi(true));
    axios
      .post(`${ep}/api/social_login/`, payload)
      .then(response => {
        if (response.success) {
          localStorage.setItem('access-token', response.data['access_token']);
          localStorage.setItem('refresh-token', response.data['refresh_token']);
          if (response.data.user_id) analytics.setLocalUserId(response.data.user_id);
          axios.defaults.headers.common['X-Access-Token'] = response.data['access_token'];
          axios.defaults.headers.common['X-Refresh-Token'] = response.data['refresh_token'];
          dispatch(loginSuccess(response.data));
          analytics.setUserContext();
          dispatch(onLoadModal({ modalType: '', modalContent: '', showModal: false }));
          if (payload.callback) payload.callback();
        }
        dispatch(requestApi(false));
      })
      .catch(err => {
        dispatch(AxiosCallError(err));
      });
  };
};

export const loginUsingGoogle = payload => {
  return (dispatch, getState) => {
    dispatch(requestApi(true));
    analytics.trackLoginMethodSelected('google');
    axios
      .post(`${ep}/api/social_login/`, payload)
      .then(response => {
        console.log('response', response);

        if (response.success) {
          // Check if it's from practices test page or regular invite
          const isPracticesTest = window.location.pathname.includes('/practices-test');

          if (isPracticesTest) {
            // For practices test page, always save to localStorage with company id 9999
            localStorage.setItem('access-token', response.data['access_token']);
            localStorage.setItem('refresh-token', response.data['refresh_token']);
            localStorage.setItem('company_id', '9999');
            axios.defaults.headers.common['X-Access-Token'] = response.data['access_token'];
            axios.defaults.headers.common['X-Refresh-Token'] = response.data['refresh_token'];
            dispatch(loginSuccess(response.data));
            dispatch(onLoadModal({ modalType: '', modalContent: '', showModal: false }));
            if (payload.callback) payload.callback();
          } else if (
            response.data.username ===
            (getState().invite.email_id?.toLowerCase() ??
              getState().project.invite.email?.toLowerCase())
          ) {
            // For regular invite page, check email match
            localStorage.setItem('access-token', response.data['access_token']);
            localStorage.setItem('refresh-token', response.data['refresh_token']);
            if (response.data.user_id) analytics.setLocalUserId(response.data.user_id);
            axios.defaults.headers.common['X-Access-Token'] = response.data['access_token'];
            axios.defaults.headers.common['X-Refresh-Token'] = response.data['refresh_token'];
            dispatch(loginSuccess(response.data));
            dispatch(onLoadModal({ modalType: '', modalContent: '', showModal: false }));
            analytics.trackGoogleLoginSuccess();
            analytics.setUserContext();
            analytics.trackLoginCompleted('google', getState().interview?.interview_id);
            if (payload.callback) payload.callback();
          } else {
            dispatch(
              showErrorPage({
                errorType: 'Application Error',
                errorHeading: 'Unauthorized access',
                errorMessage:
                  'Please make sure you are logged in as the user who received the invite',
              }),
            );
            history.push('/error');
          }
        }
        dispatch(requestApi(false));
      })
      .catch(err => {
        analytics.trackGoogleLoginFailure(err.message || 'unknown_error');
        dispatch(AxiosCallError(err));
      });
  };
};

export const loginUsingGoogleForInterview = payload => {
  return (dispatch, getState) => {
    dispatch(requestApi(true));
    analytics.trackLoginMethodSelected('google');

    axios
      .post(`${ep}/api/social_login/`, payload)
      .then(response => {
        console.log('response', response);
        let participant = getState().interview.participants.find(item => item.role === 'CA');

        if (response.success) {
          if (participant.email === response.data.username) {
            localStorage.setItem('access-token', response.data['access_token']);
            localStorage.setItem('refresh-token', response.data['refresh_token']);
            localStorage.setItem('username', response.data['username']);
            if (response.data.user_id) analytics.setLocalUserId(response.data.user_id);
            let temp = window.location.hostname.split('.').reverse();
            let root_domain = temp.length >= 2 ? '.' + temp[1] + '.' + temp[0] : '';
            document.cookie =
              'access_token=' +
              response.data['access_token'] +
              ';max-age=10800' +
              (root_domain ? ';domain=' + root_domain : '');
            document.cookie =
              'refresh_token=' +
              response.data['refresh_token'] +
              ';max-age=10800' +
              (root_domain ? ';domain=' + root_domain : '');
            axios.defaults.headers.common['X-Access-Token'] = response.data['access_token'];
            axios.defaults.headers.common['X-Refresh-Token'] = response.data['refresh_token'];
            dispatch(loginSuccess(response.data));
            dispatch(onLoadModal({ modalType: '', modalContent: '', showModal: false }));
            dispatch(fillUserId(response.data.user_id, response.data.username));
            analytics.trackGoogleLoginSuccess();
            analytics.setUserContext();
            analytics.trackLoginCompleted('google', getState().interview?.interview_id);
            if (payload.callback) payload.callback();
          } else {
            dispatch(
              showErrorPage({
                errorType: 'Application Error',
                errorHeading: 'Unauthorized access',
                errorMessage:
                  'Please make sure you are logged in as the user who received the invite',
              }),
            );
            history.push('/error');
          }
        }
        dispatch(requestApi(false));
      })
      .catch(err => {
        analytics.trackGoogleLoginFailure(err.message || 'unknown_error');
        dispatch(AxiosCallError(err));
      });
  };
};

export const loginInterviewRequest = payload => {
  return (dispatch, getState) => {
    let participants = getState().interview.participants.filter(item => item.role === 'IN');
    let valid_participant = participants.some(e => e.email === payload.emailId);
    if (valid_participant) {
      dispatch(requestApi(true));
      axios
        .post(`${ep}/api/login/`, {
          email: payload.emailId,
          password: payload.password,
        })
        .then(response => {
          if (response.success) {
            localStorage.setItem('access-token', response.data['access_token']);
            localStorage.setItem('refresh-token', response.data['refresh_token']);
            localStorage.setItem('username', response.data['username']);
            console.log('let see the userid from the response', response.data.user_id);
            if (response.data.user_id) analytics.setLocalUserId(response.data.user_id);
            let temp = window.location.hostname.split('.').reverse();
            let root_domain = temp.length >= 2 ? '.' + temp[1] + '.' + temp[0] : '';
            document.cookie =
              'access_token=' +
              response.data['access_token'] +
              ';max-age=10800' +
              (root_domain ? ';domain=' + root_domain : '');
            document.cookie =
              'refresh_token=' +
              response.data['refresh_token'] +
              ';max-age=10800' +
              (root_domain ? ';domain=' + root_domain : '');
            axios.defaults.headers.common['X-Access-Token'] = response.data['access_token'];
            axios.defaults.headers.common['X-Refresh-Token'] = response.data['refresh_token'];
            dispatch(loginSuccess(response.data));
            dispatch(onLoadModal({ modalType: '', modalContent: '', showModal: false }));
            dispatch(fillUserId(response.data.user_id, response.data.username));
            analytics.setUserContext();
            analytics.trackLoginCompleted('password', getState().interview?.interview_id);
            if (payload.callback) payload.callback();
          } else {
            openNotification({ message: 'Invalid Username/Password', type: 'failure' }, 2.5);
          }
          dispatch(requestApi(false));
        })
        .catch(error => {
          console.log('let see the error', error);
          let message =
            error.response?.data?.auth ||
            error.response?.data?.error ||
            'Invalid Username/Password';
          openNotification({ message: message, type: 'failure' }, 2.5);
          dispatch(AxiosCallError(error));
        });
    } else {
      dispatch(
        showErrorPage({
          errorType: 'Application Error',
          errorHeading: 'Unauthorized access',
          errorMessage: 'Please make sure you are logged in as the user who received the invite',
        }),
      );
      history.push('/error');
    }
  };
};

export const fillUserId = (user_id, email_id) => {
  return (dispatch, getState) => {
    let participants = getState().interview.participants;
    let participant_id = participants.find(item => item.email === email_id).id;
    let url = `${ep2}/api/participant/${participant_id}/`;
    let data = {
      user_id: user_id,
    };
    axios
      .patch(url, data)
      .then(response => {})
      .catch(error => {
        dispatch(AxiosCallError(error));
      });
  };
};

export const getMatchingCities = search_keyword => {
  return dispatch => {
    axios
      .get(`${catalog_ep}/api/catalogs/search_nodes/?node_type=2&search_query=${search_keyword}`)
      .then(response => {
        dispatch(getMatchingCitiesSuccess({ response: response.data }));
      });
  };
};

export const getAllStates = () => {
  return dispatch => {
    axios
      .get(`${catalog_ep}/api/catalogs/`)
      .then(response => {
        response.data.forEach(data => {
          if (data.name.toString() === 'Region Catalog') {
            axios
              .get(`${catalog_ep}/api/catalogs/${data.id}/nodes/?inc_child_node=NO`)
              .then(response => {
                dispatch(
                  getAllStatesSuccess({
                    states: response.data,
                  }),
                );
              })
              .catch(err => {
                dispatch(AxiosCallError(err));
              });
          }
        });
      })
      .catch(err => {
        dispatch(AxiosCallError(err));
      });
  };
};

export const FilterLocation = search_keyword => {
  return dispatch => {
    axios
      .get(`${catalog_ep}/api/location_suggest/?city_prefix=${search_keyword}`)
      .then(response => {
        dispatch(FilterLocationsSuccess({ locations: response.data }));
      });
  };
};

export const signupRequest = payload => {
  return dispatch => {
    axios.post(`${ep}/api/signup/`, payload).then(response => {
      if (response.success) {
        dispatch(onLoadModal({ modalType: '', modalContent: '', showModal: false }));
        openNotification(
          {
            message: 'Account created. Please check your email to activate your account',
            type: 'success',
          },
          2.5,
        );
        dispatch(signUpSuccess());
      } else {
        let message = '';
        Object.keys(response.data).forEach(key => {
          message = response.data[key][0];
        });

        openNotification({ message: message, type: 'failure' }, 2.5);
      }
    });
  };
};

export const SetPassword = (activation_key, payload) => {
  return dispatch => {
    axios.patch(`${ep}/api/activate/${activation_key}/`, payload).then(response => {
      if (response.success) {
        window.location.href = '/home';
        openNotification({ message: 'Password set successfully', type: 'success' }, 2.5);
      } else {
        openNotification({ message: 'Problems setting password', type: 'failure' }, 2.5);
      }
    });
  };
};

export const resetPassword = payload => {
  return dispatch => {
    axios.post(`${ep}/api/password_reset/forgot_password/`, payload).then(response => {
      if (response.success) {
        openNotification(
          {
            message: 'Reset password link sent to your email',
            type: 'success',
          },
          2.5,
        );
        dispatch(onLoadModal({ modalType: '', modalContent: '', showModal: false }));
      } else {
        openNotification(
          {
            message: 'Email provied is not registered with College Connect',
            type: 'failure',
          },
          2.5,
        );
      }
    });
  };
};

export const changePassword = payload => {
  return dispatch => {
    axios.post(`${ep}/api/password_reset/change_password/`, payload).then(response => {
      if (response.success) {
        openNotification({ title: 'Password changed successfully', type: 'success' }, 2.5);
      } else {
        openNotification({ title: 'Problem while changing password.', type: 'failure' }, 2.5);
      }
    });
  };
};

export const fetchCompanyDetails = () => dispatch => {
  let company_id = localStorage.getItem('company_id');
  // if (!company_id) return;
  axios
    .get(`${ep}/api/company_data/${company_id}`)
    .then(response => {
      document.title = `${response.data.name} Online Assessment`;
      const themeData = parseTheme(response.data.theme_data);
      if (themeData) {
        document.documentElement.style.setProperty('--header-bg', themeData.primaryColor);
        document.documentElement.style.setProperty('--selector-marker', themeData.secondaryColor);
      }
      dispatch(
        getcompanyInfoSuccess({
          company_details: {
            ...response.data,
            theme_data: themeData,
          },
        }),
      );
    })
    .catch(err => {
      dispatch(AxiosCallError(err));
    });
};

export const requestOTP = (email, login_token, company_id) => dispatch => {
  analytics.trackLoginMethodSelected('otp');
  analytics.trackOtpRequested();
  const payload = { email };
  if (company_id) {
    payload.company_id = company_id;
    localStorage.setItem('company_id', company_id); // Store company_id in localStorage
  } else if (login_token) {
    payload.login_token = login_token;
  }

  axios
    .post(`${ep}/api/otp/request/`, payload)
    .then(response => {
      dispatch(otpRequested({ message: response.data.message, status: 'send' })); // Changed to 'send' to match UI logic
    })
    .catch(err => {
      dispatch(otpFailure(err.response.data));
    });
};

export const loginOTP = (email, otp) => dispatch => {
  let company_id = localStorage.getItem('company_id');
  axios
    .post(`${ep}/api/otp/login/`, { email, otp, company_id })
    .then(response => {
      console.log('============================', response);

      analytics.trackOtpVerifiedSuccess();
      dispatch(getUserInfoSuccess(response.data));
      dispatch(otpLogin(response.data));
      axios.defaults.headers.common['X-Access-Token'] = response.data['access_token'];
      axios.defaults.headers.common['X-Refresh-Token'] = response.data['refresh_token'];
      localStorage.setItem('access-token', response.data['access_token']);
      localStorage.setItem('refresh-token', response.data['refresh_token']);
      if (response.data.user_id) analytics.setLocalUserId(response.data.user_id);
      analytics.setUserContext();
      analytics.trackLoginCompleted('otp', localStorage.getItem('interview_id'));
    })
    .catch(err => {
      analytics.trackOtpVerifiedFailure(err.response?.data?.error || 'incorrect_code');
      dispatch(otpFailure(err.response.data));
    });
};

export const resendOTP = email => dispatch => {
  axios
    .post(`${ep}/api/otp/resend/`, { email })
    .then(response => {
      dispatch(otpRequested({ message: response.data, status: 'resend' }));
    })
    .catch(err => {
      dispatch(otpFailure(err.response.data));
    });
};

export const logoutRequest = () => dispatch => {
  localStorage.clear();
  delete axios.defaults.headers.common['X-Access-Token'];
  delete axios.defaults.headers.common['X-Refresh-Token'];
};

export const loginForInterviewCA = payload => dispatch => {
  axios
    .post(`${ep}/api/otp/login/`, {
      email: payload.email,
      otp: payload.otp,
      company_id: payload.company_id,
    })
    .then(response => {
      if (response.success) {
        if (payload.email === response.data.username) {
          analytics.trackOtpVerifiedSuccess();
          localStorage.setItem('access-token', response.data['access_token']);
          localStorage.setItem('refresh-token', response.data['refresh_token']);
          localStorage.setItem('username', response.data['username']);
          if (response.data.user_id) analytics.setLocalUserId(response.data.user_id);
          let temp = window.location.hostname.split('.').reverse();
          let root_domain = temp.length >= 2 ? '.' + temp[1] + '.' + temp[0] : '';
          document.cookie =
            'access_token=' +
            response.data['access_token'] +
            ';max-age=10800' +
            (root_domain ? ';domain=' + root_domain : '');
          document.cookie =
            'refresh_token=' +
            response.data['refresh_token'] +
            ';max-age=10800' +
            (root_domain ? ';domain=' + root_domain : '');
          axios.defaults.headers.common['X-Access-Token'] = response.data['access_token'];
          axios.defaults.headers.common['X-Refresh-Token'] = response.data['refresh_token'];
          dispatch(loginSuccess(response.data));
          dispatch(otpLogin(response.data));
          dispatch(fillUserId(response.data.user_id, response.data.username));
          analytics.setUserContext();
          analytics.trackLoginCompleted('otp', localStorage.getItem('interview_id'));
          if (payload.callback) payload.callback();
        }
      }
      dispatch(requestApi(false));
    })
    .catch(err => {
      analytics.trackOtpVerifiedFailure(err.response?.data?.error || 'incorrect_code');
      dispatch(otpFailure(err.response.data));
      dispatch(AxiosCallError(err));
    });
};
